/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export const UI_EVENT_DEBOUNCE_TIME_IN_MS: number = 100;
export const USER_INPUT_DEBOUNCE_TIME_IN_MS: number = 300;
export const SYSTEM_DISPLAY_NAME = 'System';
